import React from "react";
import Cookie from "js-cookie";
import axios from "../../../../service/axios";
import SimpleReactValidator from "simple-react-validator";
import * as Validator from "../../../../utils/validations/validator";
import * as Constants from "../../../../constants/Constants";
import ContactRecord from "./ContactRecord";
import {
  PrimaryBasicContactFields,
  TechnicalBasicContactFields,
  CustomerServiceContactFields,
  ShippingContactFields,
  OtherBasicContactFields,
  AddAnotherContact,
  ContactType,
} from "./ContactFields";
import { Row, Form, Button } from "react-bootstrap";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import { objectEmpty } from "../Address/helpers";
import { isEmailValid } from "../../../../utils/utils";
import { connect } from "react-redux";
import { updateServiceData } from "../../../../redux/serviceSlice";
import { updateVendorPrimaryContact } from "../../../../redux/leftNavSlice";

const _ = require("lodash");

class ContactDetails extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      validators: {
        emailRegex: {
          message: "The :attribute must be a valid email address.",
          rule: (val, params, validator) => {
            return isEmailValid(val);
          },
          required: true,
        },
        nameRegex: {
          message:
            "The name may only contain letters, space, and special characters.",
          rule: (val) => {
            const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
            return regex.test(val);
          },
          required: true,
        },
      },
    });
    this.state = {
      primaryContact: this.props.vendorProfile?.primaryContact,
      technicalContact: this.props.vendorProfile?.technicalContact,
      customerServiceContact: this.props.vendorProfile?.customerServiceContact,
      shippingContact: this.props.vendorProfile?.shippingContact,
      otherContactList: this.props.vendorProfile?.otherContactList,
      hasErrorIndex: -1,
      editPermission: false,
      technicalCheckbox: false,
      customerServiceCheckbox: false,
      shippingCheckbox: false,
      uniqueContactError: false,
      isValidPrimaryContact: true,
      isValidTechnicalContact: true,
      isValidCustServiceContact: true,
      isValidShippingContact: true,
      rolePermissionStatus: RolePermissionConstants.NONE,
      isDisableBtn: false,
      contactUpdateStatus: false,
      contactSuccessMsg: "",
      contactUpdateErrorStatus: false,
      contactUpdateErrorMsg: "",
    };
  }

  compareSimilarContactWithPrimary = () => {
    const primaryContact = { ...this.state.primaryContact };
    const technicalContact = { ...this.state.technicalContact };
    const customerServiceContact = { ...this.state.customerServiceContact };
    const shippingContact = { ...this.state.shippingContact };

    if (this.compareSimilarContact(primaryContact, technicalContact)) {
      this.setState({ technicalCheckbox: true });
    }
    if (this.compareSimilarContact(primaryContact, customerServiceContact)) {
      this.setState({ customerServiceCheckbox: true });
    }
    if (this.compareSimilarContact(primaryContact, shippingContact)) {
      this.setState({ shippingCheckbox: true });
    }
  };

  componentDidMount() {
    this.setUserPermission();
    this.compareSimilarContactWithPrimary();
    this.reFormatPhoneNum();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.otherContactList !== this.props.otherContactList) {
      this.setOtherContactDetails();
    }
  }

  componentWillUnmount() {
    this.resetContactMessage();
    this.resetContactErrorMessage();
  }

  setOtherContactDetails = () => {
    this.setState({
      otherContactList: [...this.props.otherContactList],
    });
  };

  addOtherContactErrorFlag = (info, callback) => {
    const fieldInfo = info.split(" ");
    const index = fieldInfo[1];
    const fieldName = fieldInfo[2];
    let otherContactList = [...this.state.otherContactList];
    let otherContactAtIndex = [...this.state.otherContactList][index];
    otherContactAtIndex = {
      ...otherContactAtIndex,
      error: { ...otherContactAtIndex.error, [fieldName]: true },
    };

    otherContactList.splice(index, 1, otherContactAtIndex);
    this.setState({ otherContactList }, () => {
      if (callback) callback();
    });
  };

  reFormatPhoneNum = (state) => {
    let {
      primaryContact,
      technicalContact,
      customerServiceContact,
      shippingContact,
      otherContactList,
    } = this.state;

    primaryContact =
      primaryContact && !objectEmpty(primaryContact)
        ? {
            ...primaryContact,
            phoneNumber: this.formatPhone(primaryContact.phoneNumber),
          }
        : {};
    technicalContact =
      technicalContact && !objectEmpty(technicalContact)
        ? {
            ...technicalContact,
            phoneNumber: this.formatPhone(technicalContact.phoneNumber),
          }
        : {};
    customerServiceContact =
      customerServiceContact && !objectEmpty(customerServiceContact)
        ? {
            ...customerServiceContact,
            phoneNumber: this.formatPhone(customerServiceContact.phoneNumber),
          }
        : {};
    shippingContact =
      shippingContact && !objectEmpty(shippingContact)
        ? {
            ...shippingContact,
            phoneNumber: this.formatPhone(shippingContact.phoneNumber),
          }
        : {};
    otherContactList = otherContactList
      ? otherContactList.map((item) => ({
          ...item,
          phoneNumber: this.formatPhone(item.phoneNumber),
        }))
      : [];

    this.setState({
      primaryContact,
      technicalContact,
      customerServiceContact,
      shippingContact,
      otherContactList,
    });
  };

  compareSimilarContact = (primaryContact, toContact) => {
    if (
      primaryContact["firstName"] === toContact["firstName"] &&
      primaryContact["lastName"] === toContact["lastName"] &&
      primaryContact["email"] === toContact["email"] &&
      primaryContact["phoneNumber"] === toContact["phoneNumber"] &&
      primaryContact["extension"] === toContact["extension"]
    ) {
      return true;
    } else {
      return false;
    }
  };

  getValidateType = (field, validateType) => {
    if (
      !field.includes(Constants.VENDOR_CONTACT_PRIMARY) &&
      !field.includes(Constants.VENDOR_CONTACT_TECHNICAL) &&
      !field.includes(Constants.VENDOR_CONTACT_CUSTOMER_SER) &&
      !field.includes(Constants.VENDOR_CONTACT_SHIPPING)
    ) {
      return validateType.split("|")[1];
    }
    return validateType;
  };

  showErrorMsg = (field, index, contactType) => {
    if (
      contactType.includes(Constants.VENDOR_CONTACT_PRIMARY) &&
      !this.validator.fieldValid(field)
    ) {
      this.validator.showMessageFor(contactType);
      this.setState({ hasErrorIndex: index, isValidPrimaryContact: false });
    } else if (
      contactType.includes(Constants.VENDOR_CONTACT_TECHNICAL) &&
      !this.validator.fieldValid(field)
    ) {
      this.validator.showMessageFor(contactType);
      this.setState({ hasErrorIndex: index, isValidTechnicalContact: false });
    } else if (
      contactType.includes(Constants.VENDOR_CONTACT_CUSTOMER_SER) &&
      !this.validator.fieldValid(field)
    ) {
      this.validator.showMessageFor(contactType);
      this.setState({ hasErrorIndex: index, isValidCustServiceContact: false });
    } else if (
      contactType.includes(Constants.VENDOR_CONTACT_SHIPPING) &&
      !this.validator.fieldValid(field)
    ) {
      this.validator.showMessageFor(contactType);
      this.setState({ hasErrorIndex: index, isValidShippingContact: false });
    } else if (
      contactType.includes(Constants.VENDOR_CONTACT_OTHER) &&
      !this.validator.fieldValid(field)
    ) {
      let fieldErrorTrue = this.state.otherContactList[field.split(" ")[1]]
        ?.error?.[field.split(" ")[2]];
      if (fieldErrorTrue) {
        this.validator.showMessageFor(contactType);
        this.setState({ hasErrorIndex: index });
      } else {
        this.validator.hideMessageFor(contactType);
      }
    } else {
      this.setState({
        hasErrorIndex: -1,
        isValidPrimaryContact: true,
        isValidTechnicalContact: true,
        isValidCustServiceContact: true,
        isValidShippingContact: true,
      });
    }
  };

  showError = (type, field, value) => {
    switch (type) {
      case "email":
        return this.validator.message(
          field,
          value,
          "required|email|emailRegex"
        );
      case "alphaNumSpace":
        return this.validator.message(
          field,
          value,
          "required|" + Validator.ALPHA_NUMERIC_WITH_MUST_ALPHA_NO_SPEC_CHAR
        );
      case "phone":
        return this.validator.message(field, value, Validator.PHONE);
      case "extension":
        return this.validator.message(field, value, Validator.EXTENSION_REGEX);
      case "contactType":
        return this.validator.message(field, value, "required");
      case "alphaNumSpaceSpecChar":
        return this.validator.message(field, value, "required|nameRegex");

      default:
        break;
    }
  };

  formatPhone = (phoneNumber) => {
    let num = phoneNumber?.replace(/\D/g, "");
    if (num && num.length === 10) {
      let pn =
        "(" + num.slice(0, 3) + ") " + num.slice(3, 6) + "-" + num.slice(6);
      return pn === "()-" ? "" : pn;
    } else {
      return num || "";
    }
  };

  setValuesIntoState = (anyContact, e, role) => {
    let fieldName = e.target.getAttribute("data-id");
    anyContact[e.target.getAttribute("data-id")] =
      fieldName === "phoneNumber"
        ? this.formatPhone(e.target.value)
        : fieldName === "additionalJobRole"
        ? e.target.value.replace(/[^-/0-9a-zA-Z ]/g, "")
        : e.target.value;
    anyContact["role"] = role;
    anyContact["category"] = "Vendor";
    anyContact["vendorProfileId"] = this.props.vendorProfileId;
    anyContact["duns"] = this.props.duns;
    anyContact["userEmail"] =
      anyContact?.id !== "" && anyContact?.id !== undefined
        ? anyContact?.userEmail
        : Cookie.get("userType") === Constants.VP_USER_TYPE_EXTERNAL
        ? Cookie.get("email").toLowerCase()
        : this.props.userEmail;
    anyContact["vendorCorpName"] = this.props.vendorCorpName;
    anyContact["primaryVendor"] = role === "Primary";
    return anyContact;
  };

  setContactValues = (fromContact, toContact) => {
    toContact["firstName"] = fromContact["firstName"];
    toContact["lastName"] = fromContact["lastName"];
    (toContact["email"] = fromContact["email"]),
      (toContact["phoneNumber"] = fromContact["phoneNumber"]),
      (toContact["extension"] = fromContact["extension"]);
    return toContact;
  };

  updateContact = (contactList) => {
    let newAddresses = [...contactList].map((address) => ({
      ...address,
      vendorProfileId: this.props.vendorProfileId,
      duns: this.props.duns,
    }));

    axios()
      .post("/contact/createMultipleContacts", {
        contactList: newAddresses,
        userEmail: Cookie.get("email").toLowerCase(),
        updatedByFullName: Cookie.get("userName") ? Cookie.get("userName") : "",
      })
      .then((res) => {
        const contactDetails = res?.data;
        let updateProfileContacts = { ...this.state.profile };
        let otherContacts = [];
        this.compareSimilarContactWithPrimary();
        contactDetails?.length > 0 &&
          contactDetails.map((contact) => {
            switch (contact?.role) {
              case "Primary":
                updateProfileContacts.primaryContact = contact;
                break;
              case "Technical":
                updateProfileContacts.technicalContact = contact;
                break;
              case "CustomerService":
                updateProfileContacts.customerServiceContact = contact;
                break;
              case "Shipping":
                updateProfileContacts.shippingContact = contact;
                break;
              case "Other":
                otherContacts.push(contact);
                break;
              default:
                break;
            }
          });

        this.props.updateVendorPrimaryContact({
          vendorPhone: updateProfileContacts?.primaryContact?.phoneNumber || "",
        });

        updateProfileContacts.otherContactList =
          otherContacts && otherContacts.length > 0 ? otherContacts : [];

        if (
          this.props.onboardingStatus === Constants.VENDOR_REGISTRATION ||
          this.props.onboardingStatus === ""
        ) {
          this.setState({
            contactUpdateStatus: false,
            contactSuccessMsg: "",
            contactUpdateErrorStatus: false,
            contactUpdateErrorMsg: "",
            ...updateProfileContacts,
          });
          window.location = "/vob-confirmation";
        } else {
          this.setState({
            contactUpdateStatus: true,
            contactSuccessMsg: Constants.CONTACT_SUBMISSION,
            contactUpdateErrorStatus: false,
            contactUpdateErrorMsg: "",
            ...updateProfileContacts,
          });
        }
      })
      .catch((err) => {
        console.log("Error : " + err);
        if (err.response?.status === 400) {
          this.setState({
            contactUpdateErrorStatus: true,
            contactUpdateErrorMsg: err.response?.data?.message || "",
          });
        }
      });
  };

  resetContactMessage = () => {
    this.setState({
      contactUpdateStatus: false,
      contactSuccessMsg: "",
    });
  };

  resetContactErrorMessage = () => {
    this.setState({
      contactUpdateErrorStatus: false,
      contactUpdateErrorMsg: "",
    });
  };
  /**
   * Wrapper around setState
   * It returns a promise and resolves after the state has updated.
   */
  promisifySetState = (newState) => {
    return new Promise((resolve) => {
      this.setState(newState, () => {
        resolve();
      });
    });
  };

  changeHandler = async (e, index) => {
    const { contactUpdateStatus, contactUpdateErrorStatus } = this.state || {};
    if (contactUpdateStatus) {
      this.resetContactMessage();
    }

    if (contactUpdateErrorStatus) {
      this.resetContactErrorMessage();
    }

    if (e.target.id.indexOf("primary") > -1) {
      const primaryContact = { ...this.state.primaryContact };
      if (this.state.technicalCheckbox) {
        this.setState({ technicalCheckbox: false });
      }

      if (this.state.customerServiceCheckbox) {
        this.setState({ customerServiceCheckbox: false });
      }

      if (this.state.shippingCheckbox) {
        this.setState({ shippingCheckbox: false });
      }

      await this.promisifySetState({
        primaryContact: this.setValuesIntoState(primaryContact, e, "Primary"),
      });
    } else if (e.target.id.indexOf("technical") > -1) {
      const technicalContact = { ...this.state.technicalContact };
      const primaryContact = { ...this.state.primaryContact };

      if (
        this.state.technicalCheckbox &&
        this.compareSimilarContact(primaryContact, technicalContact)
      ) {
        await this.promisifySetState({
          technicalContact: this.setValuesIntoState(
            technicalContact,
            e,
            "Technical"
          ),
          technicalCheckbox: false,
        });
      } else {
        const isCompareWithPrimaryContact = this.compareSimilarContact(
          primaryContact,
          this.setValuesIntoState(
            technicalContact,
            e,
            Constants.VENDOR_CONTACT_TECHNICAL
          )
        );
        await this.promisifySetState({
          technicalContact: this.setValuesIntoState(
            technicalContact,
            e,
            "Technical"
          ),
        });
        if (isCompareWithPrimaryContact) {
          this.setState({ technicalCheckbox: isCompareWithPrimaryContact });
        }
      }
    } else if (e.target.id.indexOf("customerservice") > -1) {
      const customerServiceContact = { ...this.state.customerServiceContact };
      const primaryContact = { ...this.state.primaryContact };

      if (
        this.state.customerServiceCheckbox &&
        this.compareSimilarContact(primaryContact, customerServiceContact)
      ) {
        await this.promisifySetState({
          customerServiceContact: this.setValuesIntoState(
            customerServiceContact,
            e,
            "CustomerService"
          ),
          customerServiceCheckbox: false,
        });
      } else {
        const isCompareWithPrimaryContact = this.compareSimilarContact(
          primaryContact,
          this.setValuesIntoState(
            customerServiceContact,
            e,
            Constants.VENDOR_CONTACT_CUSTOMER_SERVICE
          )
        );
        await this.promisifySetState({
          customerServiceContact: this.setValuesIntoState(
            customerServiceContact,
            e,
            "CustomerService"
          ),
        });
        if (isCompareWithPrimaryContact) {
          this.setState({
            customerServiceCheckbox: isCompareWithPrimaryContact,
          });
        }
      }
    } else if (e.target.id.indexOf("shipping") > -1) {
      const shippingContact = { ...this.state.shippingContact };
      const primaryContact = { ...this.state.primaryContact };

      if (
        this.state.shippingCheckbox &&
        this.compareSimilarContact(primaryContact, shippingContact)
      ) {
        await this.promisifySetState({
          shippingContact: this.setValuesIntoState(
            shippingContact,
            e,
            "Shipping"
          ),
          shippingCheckbox: false,
        });
      } else {
        const isCompareWithPrimaryContact = this.compareSimilarContact(
          primaryContact,
          this.setValuesIntoState(
            shippingContact,
            e,
            Constants.VENDOR_CONTACT_SHIPPING
          )
        );
        await this.promisifySetState({
          shippingContact: this.setValuesIntoState(
            shippingContact,
            e,
            "Shipping"
          ),
        });
        if (isCompareWithPrimaryContact) {
          this.setState({ shippingCheckbox: isCompareWithPrimaryContact });
        }
      }
    } else if (e.target.id.indexOf("other") > -1) {
      let otherContactList = [...this.state.otherContactList];
      let otherContact = { ...otherContactList[index] };
      otherContactList[index] = this.setValuesIntoState(
        otherContact,
        e,
        "Other"
      );
      await this.promisifySetState({ otherContactList: otherContactList });
    }
  };

  handleUncheckbox(role, flag) {
    if (role.toLowerCase().indexOf("technical") > -1) {
      this.setState({ technicalCheckbox: flag });
    } else if (role.toLowerCase().indexOf("customerservice") > -1) {
      this.setState({ customerServiceCheckbox: flag });
    } else if (role.toLowerCase().indexOf("shipping") > -1) {
      this.setState({ shippingCheckbox: flag });
    }
  }

  handleCheckBox = (role, event) => {
    let contactData = { ...this.state.primaryContact };
    const { contactUpdateStatus, contactUpdateErrorStatus } = this.state || {};
    if (contactUpdateStatus) {
      this.resetContactMessage();
    }

    if (contactUpdateErrorStatus) {
      this.resetContactErrorMessage();
    }

    delete contactData["id"];
    delete contactData["createdDate"];
    delete contactData["updatedDate"];
    contactData["role"] = "Vendor";

    if (!event.target.checked) {
      contactData["firstName"] = "";
      contactData["lastName"] = "";
      contactData["email"] = "";
      contactData["phoneNumber"] = "";
      contactData["extension"] = "";

      this.handleUncheckbox(role, false);
    } else {
      this.handleUncheckbox(role, true);
    }

    this.forceUpdate();

    if (role.toLowerCase().indexOf("technical") > -1) {
      contactData["role"] = "Technical";
      if (!_.isNil(this.state.technicalContact["id"])) {
        contactData["id"] = this.state.technicalContact["id"];
      }
      this.setState({
        technicalContact: { ...contactData, primaryVendor: false },
      });
    } else if (role.toLowerCase().indexOf("customerservice") > -1) {
      contactData["role"] = "CustomerService";
      if (!_.isNil(this.state.technicalContact["id"])) {
        contactData["id"] = this.state.customerServiceContact["id"];
      }
      this.setState({
        customerServiceContact: { ...contactData, primaryVendor: false },
      });
    } else if (role.toLowerCase().indexOf("shipping") > -1) {
      contactData["role"] = "Shipping";
      if (!_.isNil(this.state.technicalContact["id"])) {
        contactData["id"] = this.state.shippingContact["id"];
      }
      this.setState({
        shippingContact: { ...contactData, primaryVendor: false },
      });
    }
  };

  handleAddAnotherContact = () => {
    let otherContactList = [...this.state.otherContactList];
    const { contactUpdateStatus, contactUpdateErrorStatus } = this.state || {};
    if (contactUpdateStatus) {
      this.resetContactMessage();
    }

    if (contactUpdateErrorStatus) {
      this.resetContactErrorMessage();
    }

    otherContactList.push({
      vendorProfileId: this.props.vendorProfileId,
      duns: this.props.duns,
      vendorCorpName: this.props.vendorCorpName,
      category: "Vendor",
      role: "Other",
      jobRole: "",
      additionalJobRole: "",
      userEmail: this.props.userEmail,
      primaryVendor: true,
      id: "",
    });
    this.setState({ otherContactList: otherContactList });
  };

  deleteContactHandler = (i) => {
    let otherContactArr = [...this.state.otherContactList];
    const { contactUpdateStatus, contactUpdateErrorStatus } = this.state || {};
    const contactId = otherContactArr[i]?.id;

    if (contactUpdateStatus) {
      this.resetContactMessage();
    }

    if (contactUpdateErrorStatus) {
      this.resetContactErrorMessage();
    }

    if (contactId !== "") {
      axios()
        .delete(`/contact/deleteContact/${contactId}`)
        .then((res) => {
          otherContactArr.splice(i, 1);
          const verifyAddresses = [
            this.state.technicalContact,
            this.state.technicalContact,
            this.state.customerServiceContact,
            this.state.shippingContact,
            ...otherContactArr,
          ];
          this.setState({ otherContactList: otherContactArr });
          if (!this.isUniqueContactEmailMoreThanOne(verifyAddresses)) {
            this.setState({ uniqueContactError: true, isDisableBtn: false });
          }
        })
        .catch((err) => {
          console.log("Error : " + err);
        });
    } else {
      otherContactArr.splice(i, 1);
      this.setState({ otherContactList: otherContactArr });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isDisableBtn: true }, () => {
      if (this.state.isDisableBtn) {
        let _technicalContact = {
          ...this.state.technicalContact,
          jobRole: "Reps",
        };
        let _customerServiceContact = {
          ...this.state.customerServiceContact,
          jobRole: "Reps",
        };
        let _shippingContact = {
          ...this.state.shippingContact,
          jobRole: "Reps",
        };
        let data = [
          this.state.primaryContact,
          _technicalContact,
          _customerServiceContact,
          _shippingContact,
          ...this.state.otherContactList,
        ];

        if (!this.isUniqueContactEmailMoreThanOne(data)) {
          this.setState({ uniqueContactError: true, isDisableBtn: false });
        } else {
          this.setState({ uniqueContactError: false });
          setTimeout(() => {
            this.updateContact(data);
            this.setState({ isDisableBtn: false });
          }, 1000);
        }
      }
    });
  };

  isUniqueContactEmailMoreThanOne(data) {
    const emailsArray = data.map((contactInfo) => contactInfo.email);
    const set = new Set(emailsArray);
    if (set.size == 1) return false;
    else return true;
  }

  handlePreviousClick = (type) => {
    this.props.updateServiceData({ fetching: true });
    this.props.history.push(
      "/boarding/vendor/" + type + "/" + (localStorage.getItem("vid") || "")
    );
  };

  setUserPermission() {
    let editPermissionFlag;
    let rolePermissionFlag;

    if (
      RolePermissionConstants.EDIT ===
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS,
        RolePermissionConstants.ALL
      )
    ) {
      editPermissionFlag = true;
      rolePermissionFlag = RolePermissionConstants.EDIT;
    } else if (
      RolePermissionConstants.VIEW ===
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS,
        RolePermissionConstants.ALL
      )
    ) {
      editPermissionFlag = false;
      rolePermissionFlag = RolePermissionConstants.VIEW;
      let formElements = document?.forms?.contactForm?.elements;
      if (formElements && formElements.length > 0) {
        for (let i = 0; i < formElements.length; i++) {
          formElements[i].disabled = true;
        }
      }
    } else {
      editPermissionFlag = false;
      rolePermissionFlag = RolePermissionConstants.NONE;
    }
    this.setState({
      editPermission: editPermissionFlag,
      rolePermissionStatus: rolePermissionFlag,
    });
  }

  convertPhoneNumber = (fieldId, phoneNumber, index, role) => {
    let temp = phoneNumber
      .replace("(", "")
      .replace(")", "")
      .replace("-", "");
    let pn =
      "(" + temp.slice(0, 3) + ")" + temp.slice(3, 6) + "-" + temp.slice(6);
    if (role === "Primary") {
      this.state.primaryContact[fieldId] = pn === "()-" ? "" : pn;
    } else if (role === "Technical") {
      this.state.technicalContact[fieldId] = pn === "()-" ? "" : pn;
    } else if (role === "CustomerService") {
      this.state.customerServiceContact[fieldId] = pn === "()-" ? "" : pn;
    } else if (role === "Shipping") {
      this.state.shippingContact[fieldId] = pn === "()-" ? "" : pn;
    } else if (role === "Other") {
      this.state.otherContactList[index][fieldId] = pn === "()-" ? "" : pn;
    }
  };

  isFormValid() {
    if (
      this.isNameValid(this.state.primaryContact.firstName) &&
      this.isNameValid(this.state.primaryContact.lastName) &&
      isEmailValid(this.state.primaryContact.email) &&
      this.isphoneNumberValid(this.state.primaryContact.phoneNumber) &&
      this.isExtensionValid(this.state.primaryContact.extension) &&
      this.isNameValid(this.state.technicalContact.firstName) &&
      this.isNameValid(this.state.technicalContact.lastName) &&
      isEmailValid(this.state.technicalContact.email) &&
      this.isphoneNumberValid(this.state.technicalContact.phoneNumber) &&
      this.isExtensionValid(this.state.technicalContact.extension) &&
      this.isCustomerServiceContactValid() &&
      this.isShippingContactValid() &&
      this.isOtherContactValid()
    ) {
      return true;
    } else {
      return false;
    }
  }

  isCustomerServiceContactValid() {
    if (
      this.state.customerServiceContact &&
      this.isNameValid(this.state.customerServiceContact.firstName) &&
      this.isNameValid(this.state.customerServiceContact.lastName) &&
      isEmailValid(this.state.customerServiceContact.email) &&
      this.isphoneNumberValid(this.state.customerServiceContact.phoneNumber) &&
      this.isExtensionValid(this.state.customerServiceContact.extension)
    ) {
      return true;
    } else return false;
  }

  isShippingContactValid() {
    if (
      this.state.shippingContact &&
      this.isNameValid(this.state.shippingContact.firstName) &&
      this.isNameValid(this.state.shippingContact.lastName) &&
      isEmailValid(this.state.shippingContact.email) &&
      this.isphoneNumberValid(this.state.shippingContact.phoneNumber) &&
      this.isExtensionValid(this.state.shippingContact.extension)
    ) {
      return true;
    } else return false;
  }

  isOtherContactValid = () => {
    const otherContacts = [...this.state.otherContactList];
    let valid = true;
    for (let i = 0; i <= otherContacts.length; i++) {
      if (valid === false) {
        break;
      }

      if (otherContacts[i]) {
        if (
          !!this.isNameValid(otherContacts[i]?.firstName || "") &&
          !!this.isNameValid(otherContacts[i]?.lastName || "") &&
          !!isEmailValid(otherContacts[i]?.email || "") &&
          !!this.isphoneNumberValid(otherContacts[i]?.phoneNumber || "") &&
          !!this.isExtensionValid(otherContacts[i]?.extension || "") &&
          !!this.isContactTypeValid(otherContacts[i]?.additionalJobRole || "")
        ) {
          valid = true;
        } else valid = false;
      }
    }

    return valid;
  };

  isNameValid(name) {
    return (
      name &&
      name.match(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/
      )
    );
  }

  isphoneNumberValid(phoneNumber) {
    return phoneNumber && phoneNumber.replace(/\D/g, "").length === 10;
  }

  isExtensionValid(extension) {
    if (extension && extension.length > 0) {
      return extension.match(/^[0-9]*$/) && extension.length <= 5
        ? true
        : false;
    } else {
      return true;
    }
  }

  isContactTypeValid = (contactType) => {
    return contactType && contactType !== "";
  };

  render() {
    const pageAccessBasedOnRole =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS,
        RolePermissionConstants.VMP_PAGEACCESS
      ) === RolePermissionConstants.VIEW;

    const isMPVendor =
      this.props.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE;

    let primaryContactFields = PrimaryBasicContactFields.map((field) => ({
      ...field,
    }));

    if (isMPVendor) {
      primaryContactFields = primaryContactFields.filter(
        (field) => field.fieldId !== "sameContact"
      );
    }

    return (
      <fieldset
        disabled={this.props.onboardingStatusFlag && !pageAccessBasedOnRole}
      >
        <>
          {!this.props.vendorProfileId && (
            <ErrorContainer
              errorMsg={
                RolePermissionConstants.VMP_VENDORPROFILEID_NOT_GENERATED
              }
              errorStatus={true}
              errorStyle="errorMessage"
            />
          )}
          <div className="container mt-4 ml-2">
            {this.state.rolePermissionStatus &&
              this.state.rolePermissionStatus !==
                RolePermissionConstants.NONE && (
                <div className="m-top-n20">
                  <div>
                    <ErrorContainer
                      updateStatus={this.state.contactUpdateStatus}
                      successMsg={this.state.contactSuccessMsg}
                      errorMsg=""
                      errorStyle="errorMessage"
                      successStyle="successMessage"
                    />
                  </div>
                  <div>
                    {this.state.contactUpdateErrorStatus && (
                      <OnSubmitErrorMessage
                        type="error"
                        message={this.state.contactUpdateErrorMsg}
                      />
                    )}
                  </div>
                  <div>
                    {this.state.uniqueContactError && (
                      <OnSubmitErrorMessage
                        type="error"
                        message={Constants.CONTACT_DISTINCT_MSG_ERROR}
                      />
                    )}
                  </div>
                  <div
                    className={`${
                      this.state.editPermission || isMPVendor
                        ? ""
                        : "disableView"
                    }`}
                  >
                    <Form name="contactForm">
                      <Form.Row>
                        <ContactRecord
                          fields={primaryContactFields}
                          role={Constants.VENDOR_CONTACT_PRIMARY}
                          contactRec={this.state.primaryContact}
                          isTechnicalChecked={this.state.technicalCheckbox}
                          isCustomerSerChecked={
                            this.state.customerServiceCheckbox
                          }
                          isShippingChecked={this.state.shippingCheckbox}
                          handleCheckBox={this.handleCheckBox}
                          showErrMsg={this.showErrorMsg}
                          showErr={this.showError}
                          hasErrorIndex={this.state.hasErrorIndex}
                          onChange={this.changeHandler}
                          disabled={!this.props.extUserEnabled || isMPVendor}
                        />
                      </Form.Row>
                      {!this.props.merchandiseType && (
                        <div>{Constants.CONTACT_DISTINCT_MSG}</div>
                      )}
                      <Form.Row>
                        <ContactRecord
                          fields={TechnicalBasicContactFields}
                          role={Constants.VENDOR_CONTACT_TECHNICAL}
                          contactRec={this.state.technicalContact}
                          handleCheckBox={this.handleCheckBox}
                          showErrMsg={this.showErrorMsg}
                          showErr={this.showError}
                          hasErrorIndex={this.state.hasErrorIndex}
                          onChange={this.changeHandler}
                          disabled={!this.props.extUserEnabled || isMPVendor}
                        />
                      </Form.Row>
                      <Form.Row>
                        <ContactRecord
                          fields={CustomerServiceContactFields}
                          role={Constants.VENDOR_CONTACT_CUSTOMER_SER}
                          contactRec={this.state.customerServiceContact}
                          handleCheckBox={this.handleCheckBox}
                          showErrMsg={this.showErrorMsg}
                          showErr={this.showError}
                          hasErrorIndex={this.state.hasErrorIndex}
                          onChange={this.changeHandler}
                          disabled={!this.props.extUserEnabled || isMPVendor}
                        />
                      </Form.Row>
                      <Form.Row>
                        <ContactRecord
                          fields={ShippingContactFields}
                          role={Constants.VENDOR_CONTACT_SHIPPING}
                          contactRec={this.state.shippingContact}
                          handleCheckBox={this.handleCheckBox}
                          showErrMsg={this.showErrorMsg}
                          showErr={this.showError}
                          hasErrorIndex={this.state.hasErrorIndex}
                          onChange={this.changeHandler}
                          disabled={!this.props.extUserEnabled || isMPVendor}
                        />
                      </Form.Row>
                      {this.state.otherContactList.map(
                        (otherContact, index) => {
                          let otherContactFields = [];
                          otherContactFields.push(
                            <div key={index}>
                              <ContactRecord
                                fields={ContactType}
                                role="Other"
                                contactRec={otherContact}
                                handleCheckBox={this.handleCheckBox}
                                showErrMsg={this.showErrorMsg}
                                showErr={this.showError}
                                hasErrorIndex={this.state.hasErrorIndex}
                                onChange={this.changeHandler}
                                deleteContactHandler={this.deleteContactHandler}
                                index={index}
                                addOtherContactErrorFlag={
                                  this.addOtherContactErrorFlag
                                }
                                disabled={
                                  (this.props.onboardingStatusFlag &&
                                    !pageAccessBasedOnRole) ||
                                  !this.props.extUserEnabled ||
                                  isMPVendor
                                }
                              />
                              <ContactRecord
                                fields={OtherBasicContactFields}
                                role={Constants.VENDOR_CONTACT_OTHER}
                                delete="Other"
                                contactRec={otherContact}
                                handleCheckBox={this.handleCheckBox}
                                showErrMsg={this.showErrorMsg}
                                showErr={this.showError}
                                hasErrorIndex={this.state.hasErrorIndex}
                                onChange={this.changeHandler}
                                deleteContactHandler={this.deleteContactHandler}
                                index={index}
                                addOtherContactErrorFlag={
                                  this.addOtherContactErrorFlag
                                }
                                disabled={
                                  (this.props.onboardingStatusFlag &&
                                    !pageAccessBasedOnRole) ||
                                  !this.props.extUserEnabled ||
                                  isMPVendor
                                }
                              />
                            </div>
                          );
                          return otherContactFields;
                        }
                      )}
                      {!isMPVendor && (
                        <Row
                          automationid={AddAnotherContact.automationId}
                          className={`addAddress ${
                            this.props.onboardingStatusFlag &&
                            !pageAccessBasedOnRole
                              ? "text-muted"
                              : ""
                          }`}
                          style={{
                            cursor:
                              this.props.onboardingStatusFlag &&
                              !pageAccessBasedOnRole
                                ? "default"
                                : "pointer",
                          }}
                          onClick={() => {
                            if (
                              (this.props.onboardingStatusFlag &&
                                !pageAccessBasedOnRole) ||
                              !this.props.extUserEnabled
                            ) {
                              return;
                            }
                            getUserRolePermission(
                              RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS,
                              RolePermissionConstants.VMP_ADDANOTHERCONTACT
                            ) === RolePermissionConstants.EDIT &&
                              this.handleAddAnotherContact();
                          }}
                        >
                          {AddAnotherContact.fieldLabel}
                        </Row>
                      )}

                      <Form.Group>
                        <Button
                          id="backbtn"
                          className="button-later-md"
                          disabled={!this.state.editPermission && !isMPVendor}
                          onClick={() => this.handlePreviousClick("address")}
                        >
                          {Constants.BUTTON_PREVIOUS}
                        </Button>
                      </Form.Group>
                      <Form.Group className="contact-btn-group">
                        <Button
                          id="updateContactBtn"
                          className="button-primary-md"
                          type="submit"
                          onClick={(event) => this.handleSubmit(event)}
                          disabled={
                            !this.props.vendorProfileId ||
                            this.state.isDisableBtn ||
                            !this.isFormValid() ||
                            !this.state.editPermission ||
                            !this.props.extUserEnabled ||
                            isMPVendor
                          }
                        >
                          {Constants.BUTTON_SUBMIT}
                        </Button>
                      </Form.Group>
                    </Form>
                  </div>
                </div>
              )}
            {this.state.rolePermissionStatus &&
              this.state.rolePermissionStatus ===
                RolePermissionConstants.NONE && (
                <div>
                  <ErrorContainer
                    errorMsg={
                      RolePermissionConstants.VMP_CONTACTDETAILS_PAGE_ACCESS_ERROR_MSG
                    }
                    errorStatus={this.state.rolePermissionStatus}
                    errorStyle="errorMessage"
                  />
                </div>
              )}
          </div>
        </>
      </fieldset>
    );
  }
}

const mapStateToProps = ({ service, common }) => ({
  vendorProfile: service.vendorProfile,
  vendorProfileId: common.profileId,
  duns: common.duns,
  onboardingStatus: common.boardingStatuses?.onboardingStatus,
  userEmail: common.userEmail,
  vendorCorpName: common.vendorCorpName,
});

const mapDispatchToProps = (dispatch) => ({
  updateServiceData: (data) => dispatch(updateServiceData(data)),
  updateVendorPrimaryContact: (data) =>
    dispatch(updateVendorPrimaryContact(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails);
